import React from 'react'
import clsx from 'clsx'
import styles from './styles/ProgressBar.module.scss'

type ProgressBarProps = {
  step: number
  maxSteps: number
  className?: string
}

export const ProgressBar: React.FC<ProgressBarProps> = props => {
  const { step, maxSteps = 1, className } = props
  const width = (step / maxSteps) * 100

  return (
    <div className={clsx(styles.container, className)}>
      <div className={styles.step} style={{ '--width': `${width}%` }}></div>
    </div>
  )
}
